import apiClient from "../api/apiClient";

export const shippingzoneService = {

    SaveZone: async (form: any) => {

         var Data={
            "ID":form.id,
    "Zone":form.name,
    "States": form.stateIds.join(","),//JSON.stringify(form.stateIds),
    "Deliverydays":form.deliveryDays,
    "Freeshippingabove":form.freeAbove,
    "Basecharge":form.freeAbove,
    "Status":form.active
    
      }

        return await apiClient.post(
            "/Shippinzone/SaveZone",
            Data,
         
        );
    },
    GetShippingzone: async (): Promise<any> => {
  
          const response =
              await apiClient.get<
                  ApiResponse<any>
              >(
                  "/Shippinzone/GetShippingzone"
              );
  
          const result =
              response.data;
  
          console.log("Testimonial Data List:", result.dataList);
  
          if (!result.isSuccess) {
  
              throw new Error(
                  result.message
              );
          }
  
          // return result.data || [];
          return result.dataList || [];
      },
      InactiveZone: async (id: number) => {
      
        const response = await apiClient.delete(
          `/Shippinzone/InactiveZone/${id}`
        );
      
        return response.data;
      },
      

      Deletezone: async (id: number) => {
      
        const response = await apiClient.delete(
          `/Shippinzone/Deletezone/${id}`
        );
      
        return response.data;
      },
      
      
  
}

export interface ApiResponse<T> {

  isSuccess: boolean;

  message: string;

  data?: T | null;

  dataList?: T | null;
}